export interface UserSignatureResponse {
  secureId: string;
}

export interface IBetaFeatureOptRequest {
  featureFlagKey: string;
  enabled: boolean;
}

export enum FeatureFlag {
  ModuleBadges = "module-badges",
  ModuleWhiteboards = "module-whiteboards",
  ModuleKpis = "module-kpis",
  ModuleTasks = "module-tasks",
  ModuleGifs = "module-gifs",
  ModuleTags = "module-tags",
  ModuleScimAccountSettings = "enable-scim-account-settings",
  ModuleReflections = "module-reflections",
  FeatureUserRoles = "roles-filter-list-employees",
  RestConnector = "restconnector",
  FeatureWhiteboardVoting = "whiteboard-voting",
  FeatureWhiteboardBasicShapes = "whiteboard-basic-shapes",
  FeatureWhiteboardRestrictShapes = "whiteboard-restrict-shapes",
  MarketplaceDirectSubmissionOfInsights = "marketplace_direct_submission_of_insights",
  HideReadonlySessions = "navigation.hide-readonly-sessions",
  NewExperienceToggle = "new-experience-toggle",
  NewExperience = "new-experience",
  LockMultiAccount = "lock-multi-account",
  AllSessionsGanntMode = "all-sessions-gantt-mode",
  FeatureSearchRecentItems = "search-recent-items",
  Italian = "italian",
  ProfilesSeeDetails = "profiles-see-details",
  OKRsShareableURLs = "okrs-shareable-urls",
  EnableTagManagement = "enable-tag-management",
  EnableInsightRenderingOptimisations = "enable-insight-rendering-optimisations",
  ChartsInLists = "charts-in-lists",
  FeatureUserAutomations = "user-automations",
  NumberFormatting = "number-formatting",
  ImprovePdfExports = "improve-pdfs-export",
  DesignScoreGrid = "okr-design-score-grid",
  ShowTheUserWhoCreated = "show-the-user-who-created",
  OrganizationChartV2 = "organization-chart-v2",
  OrganizationChartV3 = "organization-chart-v3",
  DefaultCustomSessionPermissions = "default-custom-session-permissions",
  HideExternalTeams = "hide-external-teams",
  FeatureSSOSettings = "sso-settings",
  RichTextEditor = "rich-text-editor",
  ReorderKpis = "reorder-kpis",
  PersistInsightboardFilters = "persist-insightboard-filters-per-user",
  FeatureReorderCustomFields = "reorder-custom-fields",
  WhiteboardsSessionManagement = "whiteboards-session-management",
  AndOrFilters = "and-or-filters",
  DeprecateListLoadAPI = "deprecate-list-load-api",
  WorkdayProvisioning = "workday-provisioning",
  MethodologyPerSession = "methodology-per-session",
  FeatureReflections = "reflections",
  ExcludeCachedInsightsFromCalculation = "exclude-cached-insights-from-calculation",
  HelpMenu = "help-menu",
  LessWhiteboardScreenshots = "less-whiteboard-screenshots",
  TeamsAndPeopleFilter = "teams-and-people-filter",
  AuditLog = "audit-trail",
  OwnerAccessToOkrs = "owner-access-to-okrs",
  ManageKPIsPermissions = "manage-kpis-permission",
  WhiteboardNoteToKR = "wb-note-to-kr",
  AlignmentTreeDragOrPointerNavigation = "alignment-tree-dragging-tool",
}
